(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-archive-layout"] && !Shopify.designMode) return;
  try {
    
const initialiseArchiveLayout = () => {
  const root = document.querySelector('[data-kvx-archive]');
  if (!root) return;
  const grid = root.querySelector('[data-archive-grid]');
  if (!grid) return;

  const styleButtons = root.querySelector('[data-filter-group="style"] .kvx-filter-group__buttons');
  if (styleButtons && !styleButtons.querySelector('[data-filter-value="Drón"]')) {
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.filterValue = 'Drón';
    button.setAttribute('aria-pressed', 'false');
    button.textContent = 'Drón';
    const exists = [...root.querySelectorAll('[data-gallery-item]')].some(item =>
      (item.dataset.style || '').split('||').map(value => value.trim()).includes('Drón')
    );
    button.hidden = !exists;
    styleButtons.appendChild(button);
  }

  const cards = [...grid.querySelectorAll('[data-gallery-item]')];
  const rowUnit = 8;
  const rowGap = 8;
  let frame = 0;
  let resizeTimer = 0;

  function layout() {
    frame = 0;

    if (window.innerWidth < 750) {
      cards.forEach(card => card.style.removeProperty('grid-row-end'));
      return;
    }

    cards.forEach(card => {
      if (card.hidden) return;
      const height = card.getBoundingClientRect().height;
      const rowSpan = Math.max(1, Math.ceil((height + rowGap) / (rowUnit + rowGap)));
      card.style.gridRowEnd = `span ${rowSpan}`;
    });
  }

  function requestLayout() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(layout);
  }

  const observer = new MutationObserver(mutations => {
    if (mutations.some(mutation => mutation.type === 'attributes' && mutation.attributeName === 'hidden')) {
      requestLayout();
    }
  });
  cards.forEach(card => observer.observe(card, { attributes: true, attributeFilter: ['hidden'] }));

  grid.querySelectorAll('img').forEach(image => {
    if (!image.complete) image.addEventListener('load', requestLayout, { once: true });
  });

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(requestLayout, 120);
  });

  root.addEventListener('kvx-archive-layout', layout);
  requestLayout();
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseArchiveLayout);
} else {
  initialiseArchiveLayout();
}


/* Uses the same FLIP reflow idea as the featured spread, while retaining the archive viewer. */
(() => {
  const root = document.querySelector('[data-kvx-archive]');
  const grid = root?.querySelector('[data-archive-grid]');
  if (!grid || grid.dataset.spreadReady === 'true') return;
  grid.dataset.spreadReady = 'true';
  const cards = [...grid.querySelectorAll('[data-gallery-item]')];
  const motionAllowed = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let selected = null;

  const escapeHtml = value => String(value || '').replace(/[&<>"']/g, character =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[character]));

  function reflow(change, active) {
    const visible = cards.filter(card => !card.hidden);
    const before = new Map(visible.map(card => [card, card.getBoundingClientRect()]));
    const imageBefore = active?.querySelector('.kvx-archive-card__image')?.getBoundingClientRect();
    change();
    root.dispatchEvent(new Event('kvx-archive-layout'));
    // Measure the new intrinsic height before keeping the chosen image near its original viewport position.
    const topAfter = active?.getBoundingClientRect().top;
    const topBefore = before.get(active)?.top;
    if (topBefore !== undefined && topAfter !== undefined && !active.hidden) {
      window.scrollBy(0, topAfter - topBefore);
    }
    if (!motionAllowed) return;
    visible.forEach(card => {
      const first = before.get(card);
      const last = card.getBoundingClientRect();
      if (!first || !last.width || !last.height || card === active) return;
      const dx = first.left - last.left, dy = first.top - last.top;
      if (dx || dy) card.animate(
        [{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'translate(0, 0)' }],
        { duration: 620, easing: 'cubic-bezier(.2,.75,.2,1)' }
      );
    });
    const image = active?.querySelector('.kvx-archive-card__image');
    const imageAfter = image?.getBoundingClientRect();
    if (imageBefore && imageAfter?.width && imageAfter?.height) {
      image.animate([
        { transform: `translate(${imageBefore.left - imageAfter.left}px, ${imageBefore.top - imageAfter.top}px) scale(${imageBefore.width / imageAfter.width}, ${imageBefore.height / imageAfter.height})`, transformOrigin: 'top left', opacity: .82 },
        { transform: 'none', transformOrigin: 'top left', opacity: 1 }
      ], { duration: 680, easing: 'cubic-bezier(.2,.75,.2,1)' });
    }
  }

  function setHeroSource(card, expanded) {
    const image = card.querySelector('.kvx-archive-card__image img');
    if (!image) return;
    if (!image.dataset.archiveOriginalSizes) image.dataset.archiveOriginalSizes = image.sizes || '100vw';
    image.sizes = expanded ? '(min-width: 990px) 75vw, 100vw' : image.dataset.archiveOriginalSizes;
  }

  function collapse(returnFocus = false) {
    if (!selected) return;
    const card = selected;
    selected = null;
    reflow(() => {
      card.classList.remove('is-expanded');
      setHeroSource(card, false);
      card.querySelector('.kvx-archive-card__spread')?.remove();
      card.querySelector('[data-kvx-archive-fullscreen]')?.remove();
      card.querySelector('[data-kvx-gallery-trigger]')?.setAttribute('aria-expanded', 'false');
    }, card);
    if (returnFocus) card.querySelector('[data-kvx-gallery-trigger]')?.focus({ preventScroll: true });
  }

  function expand(card) {
    const old = selected;
    const mosaicImageHeight = card.querySelector('.kvx-archive-card__image img')?.getBoundingClientRect().height;
    if (mosaicImageHeight) card.style.setProperty('--kvx-mosaic-image-height', `${Math.ceil(mosaicImageHeight)}px`);
    const data = card.querySelector('[data-kvx-gallery-data]')?.content.querySelector('div');
    const title = data?.dataset.title || card.querySelector('.kvx-archive-card__meta span')?.textContent || '';
    const location = data?.dataset.location || '';
    const productUrl = data?.dataset.productUrl || '';
    const spread = document.createElement('div');
    spread.className = 'kvx-archive-card__spread';
    spread.innerHTML = `<button type="button" class="kvx-archive-card__spread-close" aria-label="Kibontott kép bezárása">×</button><h3>${escapeHtml(title)}</h3>${location ? `<p class="kvx-archive-card__spread-location">${escapeHtml(location)}</p>` : ''}<div class="kvx-archive-card__spread-actions">${productUrl ? `<a href="${escapeHtml(productUrl)}">Megvásárolom</a>` : ''}</div>`;
    const fullscreen = document.createElement('button');
    fullscreen.type = 'button';
    fullscreen.className = 'kvx-archive-card__fullscreen';
    fullscreen.dataset.kvxArchiveFullscreen = '';
    fullscreen.textContent = 'Teljes képernyő';
    selected = card;
    reflow(() => {
      if (old) {
        old.classList.remove('is-expanded');
        setHeroSource(old, false);
        old.querySelector('.kvx-archive-card__spread')?.remove();
        old.querySelector('[data-kvx-archive-fullscreen]')?.remove();
        old.querySelector('[data-kvx-gallery-trigger]')?.setAttribute('aria-expanded', 'false');
      }
      card.classList.add('is-expanded');
      setHeroSource(card, true);
      card.querySelector('[data-kvx-gallery-trigger]')?.setAttribute('aria-expanded', 'true');
      card.querySelector('.kvx-gallery-card-media')?.append(fullscreen);
      card.append(spread);
    }, card);
    spread.querySelector('.kvx-archive-card__spread-close').addEventListener('click', () => collapse(true));
    requestAnimationFrame(() => {
      if (selected !== card) return;
      const media = card.querySelector('.kvx-gallery-card-media');
      const image = card.querySelector('.kvx-archive-card__image');
      if (!media || !image) return;
      const viewportHeight = window.innerHeight;
      const topMargin = Math.min(96, Math.max(24, viewportHeight * .1));
      const bottomMargin = 24;
      const imageTop = card.getBoundingClientRect().top + media.offsetTop + image.offsetTop;
      const imageBottom = imageTop + image.offsetHeight;
      const availableHeight = viewportHeight - topMargin - bottomMargin;
      const delta = image.offsetHeight > availableHeight
        ? imageTop - topMargin
        : imageTop < topMargin
          ? imageTop - topMargin
          : imageBottom > viewportHeight - bottomMargin
            ? imageBottom - (viewportHeight - bottomMargin)
            : 0;
      if (Math.abs(delta) > 2) window.scrollBy({ top: delta, behavior: motionAllowed ? 'smooth' : 'instant' });
    });
  }

  // The image toggles the in-place spread; the dedicated button opens fullscreen.
  root.addEventListener('click', event => {
    const trigger = event.target.closest('[data-kvx-gallery-trigger]');
    if (!trigger || !grid.contains(trigger)) return;
    const card = trigger.closest('[data-gallery-item]');
    if (!card) return;
    event.preventDefault();
    event.stopPropagation();
    if (card === selected) collapse(false);
    else expand(card);
  }, true);
  root.addEventListener('kvx-archive-filtered', () => {
    if (selected?.hidden) collapse(false);
  });
})();

(() => {
  const viewer = document.querySelector('[data-kvx-gallery-viewer]');
  if (!viewer || viewer.dataset.ready === 'true') return;
  viewer.dataset.ready = 'true';

  const image = viewer.querySelector('[data-kvx-viewer-image]');
  const title = viewer.querySelector('[data-kvx-viewer-title]');
  const counter = viewer.querySelector('[data-kvx-viewer-counter]');
  const product = viewer.querySelector('[data-kvx-viewer-product]');
  const enquiry = viewer.querySelector('[data-kvx-viewer-enquiry]');
  const stage = viewer.querySelector('[data-kvx-viewer-stage]');
  const heart = viewer.querySelector('[data-kvx-viewer-heart]');
  const heartLabel = viewer.querySelector('[data-kvx-viewer-heart-label]');
  let entries = [];
  let currentItem = null;
  let current = 0;
  let opener = null;
  let viewerScrollY = 0;
  let touchStartX = null;
  let touchStartY = null;
  let flight = null;
  let closing = false;
  const motionAllowed = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function imageRect(element, ratio = element.naturalWidth / element.naturalHeight) {
    const box = element.getBoundingClientRect();
    if (!ratio || !box.width || !box.height) return null;
    const width = Math.min(box.width, box.height * ratio);
    const height = width / ratio;
    return { left: box.left + (box.width - width) / 2, top: box.top + (box.height - height) / 2, width, height };
  }

  function clearFlight() {
    if (!flight) return;
    flight.animation?.cancel();
    flight.clone.remove();
    flight = null;
    image.style.visibility = '';
    viewer.classList.remove('is-opening');
  }

  function makeFlight(source, from, to, onFinish) {
    if (!source || !from || !to) { onFinish(); return; }
    const clone = document.createElement('img');
    clone.className = 'kvx-gallery-viewer__flight';
    clone.alt = '';
    clone.src = source;
    viewer.append(clone);
    const animation = clone.animate([
      { left: `${from.left}px`, top: `${from.top}px`, width: `${from.width}px`, height: `${from.height}px` },
      { left: `${to.left}px`, top: `${to.top}px`, width: `${to.width}px`, height: `${to.height}px` }
    ], { duration: 520, easing: 'cubic-bezier(.22,.76,.22,1)', fill: 'forwards' });
    flight = { clone, animation };
    animation.finished.then(() => {
      if (flight?.animation !== animation) return;
      onFinish();
    }).catch(() => {});
  }

  function isSaved(id) {
    try {
      const items = JSON.parse(localStorage.getItem('kvx-shortlist:v1'));
      return Array.isArray(items) && items.some(item => item.id === id);
    } catch (error) {
      return false;
    }
  }

  function syncHeart() {
    const yes = currentItem && isSaved(currentItem.id);
    heart.classList.toggle('is-saved', Boolean(yes));
    heart.setAttribute('aria-pressed', yes ? 'true' : 'false');
    heart.setAttribute('aria-label', yes ? 'Eltávolítás a válogatásból' : 'Mentés a válogatásba');
    heartLabel.textContent = yes ? 'Eltávolítás a válogatásból' : 'Mentés a válogatásba';
  }

  function render(index) {
    clearFlight();
    if (!entries.length) return;
    current = (index + entries.length) % entries.length;
    const template = entries[current].querySelector('[data-kvx-gallery-data]');
    const data = template?.content.querySelector('div');
    if (!data) return;

    const fallback = entries[current].querySelector('img')?.currentSrc || entries[current].querySelector('img')?.src || '';
    const source = data.dataset.src || fallback;
    currentItem = {
      id: data.dataset.artworkId || (data.dataset.productUrl ? 'product:' + data.dataset.productUrl : 'image:' + data.dataset.src),
      title: data.dataset.title || '',
      reference: data.dataset.reference || '',
      thumb: fallback || data.dataset.src,
      src: data.dataset.src || fallback,
      productUrl: data.dataset.productUrl || '',
    };
    syncHeart();
    image.classList.remove('is-changing');
    image.removeAttribute('src');
    image.onerror = () => {
      if (fallback && image.src !== fallback) image.src = fallback;
    };
    image.src = source;
    image.alt = data.dataset.title || '';
    title.textContent = data.dataset.title || '';
    counter.textContent = `${current + 1} / ${entries.length}`;
    if (data.dataset.productUrl) {
      product.href = data.dataset.productUrl;
      product.hidden = false;
      enquiry.hidden = true;
    } else {
      product.hidden = true;
      product.removeAttribute('href');
      enquiry.hidden = false;
    }
  }

  function openFrom(trigger) {
    const group = trigger.closest('[data-kvx-gallery-group]');
    if (!group) return;
    entries = [...group.querySelectorAll('[data-kvx-gallery-entry]')].filter(entry => !entry.hidden);
    const entry = trigger.closest('[data-kvx-gallery-entry]');
    const index = entries.indexOf(entry);
    if (index < 0) return;
    const sourceImage = entry.classList.contains('is-expanded') ? entry.querySelector('.kvx-archive-card__image img') : null;
    const from = sourceImage ? imageRect(sourceImage) : null;
    opener = trigger;
    viewerScrollY = window.scrollY;
    render(index);
    if (from && motionAllowed) viewer.classList.add('is-opening');
    viewer.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (from && sourceImage && motionAllowed) {
      image.style.visibility = 'hidden';
      requestAnimationFrame(() => {
        if (!viewer.open) return;
        const to = imageRect(image, sourceImage.naturalWidth / sourceImage.naturalHeight);
        if (!to) {
          image.style.visibility = '';
          viewer.classList.remove('is-opening');
          return;
        }
        makeFlight(sourceImage.currentSrc || sourceImage.src, from, to, () => {
          const finish = () => {
            if (!viewer.open || !viewer.classList.contains('is-opening')) return;
            clearFlight();
          };
          if (image.complete && image.naturalWidth) finish();
          else {
            image.addEventListener('load', finish, { once: true });
            image.addEventListener('error', finish, { once: true });
            window.setTimeout(finish, 1800);
          }
        });
      });
    }
  }

  function closeViewer() {
    if (!viewer.open || closing) return;
    clearFlight();
    image.style.visibility = '';
    const entry = opener?.closest('[data-kvx-gallery-entry]');
    const sourceImage = entry?.classList.contains('is-expanded') && entries[current] === entry
      ? entry.querySelector('.kvx-archive-card__image img') : null;
    const from = sourceImage && image.naturalWidth ? imageRect(image) : null;
    const to = sourceImage ? imageRect(sourceImage) : null;
    if (!motionAllowed) { viewer.close(); return; }
    if (!from || !to) {
      closing = true;
      viewer.classList.add('is-closing');
      window.setTimeout(() => { if (viewer.open) viewer.close(); }, 320);
      return;
    }
    closing = true;
    viewer.classList.add('is-closing');
    const finish = () => {
      if (!closing || !viewer.open) return;
      clearFlight();
      viewer.close();
    };
    makeFlight(image.currentSrc || image.src, from, to, finish);
    window.setTimeout(finish, 850);
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-kvx-gallery-trigger], [data-kvx-archive-fullscreen]');
    if (trigger) openFrom(trigger);
  });

  heart.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    if (currentItem) {
      window.dispatchEvent(new CustomEvent('kvx-shortlist-toggle', { detail: currentItem }));
    }
  });

  enquiry.addEventListener('click', () => {
    if (currentItem) {
      window.dispatchEvent(new CustomEvent('kvx-shortlist-enquire', { detail: currentItem }));
    }
  });

  window.addEventListener('kvx-shortlist-change', syncHeart);

  viewer.querySelector('[data-kvx-viewer-close]').addEventListener('click', closeViewer);
  viewer.querySelector('[data-kvx-viewer-prev]').addEventListener('click', () => render(current - 1));
  viewer.querySelector('[data-kvx-viewer-next]').addEventListener('click', () => render(current + 1));

  viewer.addEventListener('click', event => {
    if (event.target === viewer) closeViewer();
  });

  viewer.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      render(current - 1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      render(current + 1);
    }
  });

  viewer.addEventListener('cancel', event => {
    event.preventDefault();
    closeViewer();
  });

  viewer.addEventListener('close', () => {
    clearFlight();
    closing = false;
    viewer.classList.remove('is-closing');
    image.style.visibility = '';
    document.documentElement.style.removeProperty('overflow');
    image.src = '';
    requestAnimationFrame(() => {
      if (opener?.isConnected) opener.focus({ preventScroll: true });
      window.scrollTo({ top: viewerScrollY, behavior: 'instant' });
    });
  });

  stage.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    touchStartX = event.clientX;
    touchStartY = event.clientY;
  });

  stage.addEventListener('pointerup', event => {
    if (touchStartX === null || touchStartY === null) return;
    const deltaX = event.clientX - touchStartX;
    const deltaY = event.clientY - touchStartY;
    touchStartX = null;
    touchStartY = null;
    if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
    render(deltaX < 0 ? current + 1 : current - 1);
  });

  stage.addEventListener('pointercancel', () => {
    touchStartX = null;
    touchStartY = null;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-archive"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-kvx-archive]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const items = [...root.querySelectorAll('[data-gallery-item]')];
  const keys = ['theme','light','mood','style','color','orientation','location'];
  const state = Object.fromEntries(keys.map(key => [key, new Set()]));
  const count = root.querySelector('[data-result-count]');
  const activeCount = root.querySelector('[data-active-filter-count]');
  const reset = root.querySelector('[data-filter-reset]');
  const empty = root.querySelector('[data-empty-state]');
  const panel = root.querySelector('[data-filter-panel]');
  const toggle = root.querySelector('[data-filter-toggle]');

  const valuesFor = (item, key) => (item.dataset[key] || '').split('||').map(v => v.trim()).filter(Boolean);
  const activeTotal = () => keys.reduce((sum, key) => sum + state[key].size, 0);

  root.querySelectorAll('[data-filter-group]').forEach(group => {
    const key = group.dataset.filterGroup;
    let available = 0;
    group.querySelectorAll('[data-filter-value]').forEach(button => {
      const exists = items.some(item => valuesFor(item, key).includes(button.dataset.filterValue));
      button.hidden = !exists;
      if (exists) available++;
    });
    group.hidden = available === 0;
  });

  function matchesKey(item, key, extraValue = null) {
    const required = [...state[key]];
    if (extraValue && !required.includes(extraValue)) required.push(extraValue);
    if (!required.length) return true;
    const itemValues = valuesFor(item, key);
    return required.every(value => itemValues.includes(value));
  }

  function matchesAll(item, extraKey = null, extraValue = null) {
    return keys.every(key => matchesKey(item, key, key === extraKey ? extraValue : null));
  }

  function updateAvailability() {
    root.querySelectorAll('[data-filter-group]').forEach(group => {
      const key = group.dataset.filterGroup;
      group.querySelectorAll('[data-filter-value]').forEach(button => {
        if (button.hidden) return;
        const value = button.dataset.filterValue;
        const selected = state[key].has(value);
        button.disabled = !selected && !items.some(item => matchesAll(item, key, value));
      });
    });
  }

  function syncControls() {
    root.querySelectorAll('[data-filter-group]').forEach(group => {
      const selected = state[group.dataset.filterGroup];
      group.querySelectorAll('[data-filter-value]').forEach(button => {
        const on = selected.has(button.dataset.filterValue);
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
    const total = activeTotal();
    activeCount.textContent = total ? `(${total})` : '';
    reset.hidden = total === 0;
  }

  function applyFilters() {
    let visible = 0;
    items.forEach(item => {
      const show = matchesAll(item);
      item.hidden = !show;
      if (show) visible++;
    });
    count.textContent = visible === 1 ? '1 kép' : `${visible} kép`;
    empty.hidden = visible !== 0;
    syncControls();
    updateAvailability();
    root.dispatchEvent(new Event('kvx-archive-filtered'));
  }

  root.querySelectorAll('[data-filter-group]').forEach(group => {
    group.addEventListener('click', event => {
      const button = event.target.closest('[data-filter-value]');
      if (!button || button.hidden || button.disabled) return;
      const selected = state[group.dataset.filterGroup];
      const value = button.dataset.filterValue;
      selected.has(value) ? selected.delete(value) : selected.add(value);
      applyFilters();
    });
  });

  function resetFilterState() {
    keys.forEach(key => state[key].clear());
  }

  reset.addEventListener('click', () => {
    resetFilterState();
    applyFilters();
  });

  if (toggle) toggle.addEventListener('click', () => {
    const open = panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  const hashMap = {
    'tema-vitorlas':['theme','Vitorlás'],
    'tema-tajkep':['theme','Tájkép'],
    'tema-kikoto':['theme','Kikötő'],
    'tema-absztrakt':['theme','Absztrakt']
  };

  function applyHashFilter({ scroll = true } = {}) {
    const hash = location.hash.replace('#','');
    if (hash === 'all-balaton') {
      resetFilterState();
      applyFilters();
      if (scroll) setTimeout(() => root.scrollIntoView({behavior:'smooth'}), 50);
      return;
    }
    if (!hashMap[hash]) return;
    resetFilterState();
    const [key, value] = hashMap[hash];
    const button = [...root.querySelectorAll(`[data-filter-group="${key}"] [data-filter-value]`)].find(b => b.dataset.filterValue === value && !b.hidden);
    if (!button) return;
    state[key].add(value);
    applyFilters();
    if (scroll) setTimeout(() => root.scrollIntoView({behavior:'smooth'}), 50);
  }

  if (location.hash) applyHashFilter({ scroll: true });
  else applyFilters();
  window.addEventListener('hashchange', () => applyHashFilter({ scroll: true }));


  const disclosure = root.querySelector('[data-filter-disclosure]');
  root.querySelectorAll('[data-preset-group]').forEach(card => {
    card.addEventListener('click', event => {
      event.preventDefault();
      const group = card.dataset.presetGroup;
      const value = card.dataset.presetValue;
      if (!group || !value) return;
      if (reset) reset.click();
      const targetGroup = root.querySelector(`[data-filter-group="${CSS.escape(group)}"]`);
      if (!targetGroup) return;
      const button = [...targetGroup.querySelectorAll('[data-filter-value]')].find(candidate => candidate.dataset.filterValue === value && !candidate.hidden);
      if (button && !button.disabled) button.click();
      if (disclosure) disclosure.open = false;
      setTimeout(() => root.scrollIntoView({behavior:'smooth',block:'start'}), 40);
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-kvx-featured-editorial]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  const grid = root.querySelector('[data-kvx-featured-grid]');
  const cards = [...root.querySelectorAll('[data-kvx-featured-entry]')];
  const filters = [...root.querySelectorAll('[data-kvx-featured-filter]')];
  const viewer = root.querySelector('[data-kvx-featured-viewer]');
  const viewerImage = root.querySelector('[data-kvx-viewer-image]');
  const viewerTitle = root.querySelector('[data-kvx-viewer-title]');
  const viewerCounter = root.querySelector('[data-kvx-viewer-counter]');
  const viewerHeart = root.querySelector('[data-kvx-viewer-heart]');
  const viewerStage = root.querySelector('[data-kvx-viewer-stage]');
  const purchase = root.querySelector('[data-kvx-purchase]');
  const purchaseTitle = root.querySelector('[data-kvx-purchase-title]');
  const purchaseOptions = root.querySelector('[data-kvx-purchase-options]');
  const productLink = root.querySelector('[data-kvx-product-link]');
  let current = null;
  let viewerCard = null;
  let viewerOrigin = null;
  let viewerScrollY = 0;
  let focusFrame = 0;
  let visualScrollY = window.scrollY;
  let lastFocusTime = 0;
  let nativeTouchScroll = false;
  let touchScrollHeld = false;
  let nativeTouchLastY = window.scrollY;
  let nativeTouchStillFrames = 0;
  let wheelFrame = 0;
  let wheelVelocity = 0;
  let wheelPosition = window.scrollY;
  let wheelFrameTime = 0;
  let wheelDriving = false;
  let fineWheelUntil = 0;
  const wheelDecayMs = 62;
  let touchStart = null;
  let viewerSwipeHandled = false;
  const terms = { artistic: ['művészi', 'festményszerű'], harbours: ['kikötő', 'marina', 'port'], drone: ['drón', 'drone'], abstract: ['absztrakt', 'abstract'] };
  const normalize = value => String(value || '').toLocaleLowerCase('hu-HU');
  const escapeHtml = value => String(value || '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[character]));
  const dataFor = card => card.querySelector('[data-kvx-gallery-data]')?.content.querySelector('div');
  const purchaseTemplateFor = card => card.querySelector('[data-kvx-purchase-template]');
  const visibleCards = () => cards.filter(card => !card.hidden);
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const filterBar = root.querySelector('.kvx-featured-editorial__filters-wrap');
  const finale = root.querySelector('[data-kvx-featured-finale]');
  const finaleScreen = root.querySelector('[data-kvx-finale-screen]');
  const finaleContent = root.querySelector('[data-kvx-finale-content]');
  const clamp = value => Math.max(0, Math.min(1, value));
  const smooth = (start, end, value) => { const t = clamp((value - start) / (end - start)); return t * t * (3 - 2 * t); };
  const layoutTop = element => {
    let top = 0;
    let node = element;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  };

  function shortlistItem(card) {
    const data = dataFor(card)?.dataset || {};
    return { id: data.artworkId || (data.productUrl ? `product:${data.productUrl}` : `image:${data.src}`), title: data.title || '', reference: data.reference || '', src: data.src || '', thumb: card.querySelector('img')?.currentSrc || '', productUrl: data.productUrl || '' };
  }

  function renderStory(card, index) {
    const data = dataFor(card)?.dataset;
    if (!data) return;
    const { location = '', date = '', intent = '', description = '' } = data;
    const hasProduct = Boolean(data.productUrl && purchaseTemplateFor(card));
    const story = document.createElement('div');
    story.className = 'kvx-featured-editorial__spread';
    story.dataset.kvxFeaturedSpread = '';
    story.innerHTML = `<span class="kvx-featured-editorial__index">KIEMELT KÉP · ${String(index + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}</span><p class="kvx-featured-editorial__meta">${location ? `<span>${escapeHtml(location)}</span>` : ''}${date ? `<span>${escapeHtml(date)}</span>` : ''}</p><h2>${escapeHtml(data.title || '')}</h2><div class="kvx-featured-editorial__copy">${intent ? `<p><strong>Alkotói szándék</strong>${escapeHtml(intent)}</p>` : ''}${description ? `<p><strong>A képről</strong>${escapeHtml(description)}</p>` : ''}${!intent && !description ? '<p>Az alkotói történet és a kép részletei hamarosan itt jelennek meg.</p>' : ''}</div><div class="kvx-featured-editorial__actions">${hasProduct ? '<button class="button" type="button" data-kvx-buy>Megvásárolom</button>' : '<button class="button button--secondary" type="button" data-kvx-enquire>Érdeklődöm</button>'}</div>`;
    card.append(story);
    story.querySelector('[data-kvx-buy]')?.addEventListener('click', () => openPurchase(card));
    story.querySelector('[data-kvx-enquire]')?.addEventListener('click', () => window.dispatchEvent(new CustomEvent('kvx-shortlist-enquire', { detail: shortlistItem(card) })));
  }

  // One pair and one quiet background belong to the exhibition stage itself.
  const apexLines = ['before', 'after'].map(side => {
    const line = document.createElement('span');
    line.className = 'kvx-featured-editorial__apex-line';
    line.dataset.kvxApexLine = side;
    line.setAttribute('aria-hidden', 'true');
    root.append(line);
    return line;
  });
  const apexZone = document.createElement('span');
  apexZone.className = 'kvx-featured-editorial__apex-zone';
  apexZone.setAttribute('aria-hidden', 'true');
  root.append(apexZone);

  function updateFocus(now = performance.now()) {
    focusFrame = 0;
    if (viewer.open || purchase.open) {
      visualScrollY = window.scrollY;
      lastFocusTime = 0;
      return;
    }
    const actualScrollY = window.scrollY;
    const touchScrollY = window.visualViewport?.pageTop ?? actualScrollY;
    const targetScrollY = nativeTouchScroll ? touchScrollY : actualScrollY;
    if (motionPreference.matches || wheelDriving) visualScrollY = actualScrollY;
    else if (nativeTouchScroll) visualScrollY = touchScrollY;
    else {
      const elapsed = Math.min(24, Math.max(8, lastFocusTime ? now - lastFocusTime : 16));
      visualScrollY += (actualScrollY - visualScrollY) * (1 - Math.exp(-elapsed / 42));
      if (Math.abs(actualScrollY - visualScrollY) < .25) visualScrollY = actualScrollY;
    }
    lastFocusTime = now;
    const visible = visibleCards();
    const viewport = window.innerHeight;
    const filterBottom = nativeTouchScroll
      ? Math.max(Number.parseFloat(getComputedStyle(filterBar).top) || 0, layoutTop(filterBar) - visualScrollY) + filterBar.offsetHeight
      : filterBar.getBoundingClientRect().bottom;
    const rootTop = nativeTouchScroll ? layoutTop(root) - visualScrollY : root.getBoundingClientRect().top;
    const finaleTop = nativeTouchScroll ? layoutTop(finale) : finale.getBoundingClientRect().top + actualScrollY;
    const rootPadding = Number.parseFloat(getComputedStyle(root).paddingBottom) || 0;
    const dwellHalf = Math.min(105, Math.max(72, viewport * .1));
    const measurements = visible.map(card => {
      const visual = card.querySelector('.kvx-featured-editorial__visual');
      const story = card.querySelector('[data-kvx-featured-spread]');
      const cardLayoutTop = nativeTouchScroll ? layoutTop(card) : 0;
      const actualCardTop = nativeTouchScroll ? cardLayoutTop - visualScrollY : card.getBoundingClientRect().top;
      const cardTop = nativeTouchScroll ? cardLayoutTop - visualScrollY : actualCardTop + actualScrollY - visualScrollY;
      const panorama = card.dataset.kvxFeaturedPanorama === 'true';
      const portrait = card.dataset.kvxFeaturedPortrait === 'true';
      const height = visual.offsetHeight;
      const portraitPeak = portrait ? Math.min(1.045, Math.max(1, viewport * .79 / Math.max(height, 1))) : 1;
      const line = panorama ? filterBottom + 16 + height / 2
        : Math.max(viewport * (portrait ? .485 : .505), filterBottom + 10 + height * (portrait ? portraitPeak : 1) / 2);
      // Use layout coordinates: measuring the transformed element would feed last
      // frame's movement back into the next frame and make slow scrolling wobble.
      return { card, visual, story, panorama, portrait, portraitPeak, cardTop, center: cardTop + visual.offsetTop + height / 2, actualCenter: actualCardTop + visual.offsetTop + height / 2, height, storyTop: cardTop + story.offsetTop, actualStoryTop: actualCardTop + story.offsetTop, storyHeight: story.offsetHeight, line };
    });
    measurements.forEach(item => { item.apexY = visualScrollY + item.center - item.line; });
    let nearest = null;
    let nearestDistance = Infinity;
    measurements.forEach(item => {
      const { center, line } = item;
      const distance = Math.abs(center - line);
      if (distance < nearestDistance) { nearest = item.card; nearestDistance = distance; }
      if (motionPreference.matches) return;
      // Keep the established approach/release proximity for position, brightness and depth.
      const reach = viewport * .82;
      const shoulder = .17;
      const travel = Math.max(0, Math.min(1, (distance - dwellHalf) / reach));
      const arrival = travel < shoulder
        ? (travel ** 3 / shoulder ** 2 - travel ** 4 / (2 * shoulder ** 3)) / (1 - shoulder / 2)
        : (travel - shoulder / 2) / (1 - shoulder / 2);
      const proximity = 1 - arrival;
      const precedingLimit = item.panorama ? .39 : .265;
      const baselineLift = center < line
        ? Math.min(viewport * precedingLimit, (line - center) * .5)
        : -Math.min(viewport * .23, (center - line) * .3);
      const settle = proximity ** 4;
      item.lift = baselineLift + ((line - center) * .88 - baselineLift) * settle;
      item.proximity = proximity;
      item.visual.style.setProperty('--kvx-dim', (.76 * (1 - proximity)).toFixed(3));
      item.visual.style.setProperty('--kvx-shadow-opacity', (proximity ** 5 * (item.panorama ? .14 : .23)).toFixed(3));
      item.story.style.setProperty('--kvx-story-opacity', (item.panorama ? proximity ** 3 : .22 + .78 * proximity).toFixed(3));
    });
    if (!motionPreference.matches) {
      // The adjacent pair exchanges scale only between their dwell boundaries.
      // Within a hero dwell, both neighbors stay at their receded endpoints.
      measurements.forEach((item, index) => {
        const previous = measurements[index - 1];
        const next = measurements[index + 1];
        let scaleProgress = 1;
        if (visualScrollY < item.apexY - dwellHalf) {
          if (previous) {
            const distance = Math.max(1, item.apexY - previous.apexY - 2 * dwellHalf);
            scaleProgress = clamp((visualScrollY - previous.apexY - dwellHalf) / distance);
          } else {
            const travel = clamp((item.apexY - dwellHalf - visualScrollY) / (viewport * .82));
            scaleProgress = 1 - travel ** 3 * (4 - 3 * travel);
          }
        } else if (visualScrollY > item.apexY + dwellHalf) {
          if (next) {
            const distance = Math.max(1, next.apexY - item.apexY - 2 * dwellHalf);
            scaleProgress = 1 - clamp((visualScrollY - item.apexY - dwellHalf) / distance);
          } else {
            const travel = clamp((visualScrollY - item.apexY - dwellHalf) / (viewport * .82));
            scaleProgress = 1 - travel ** 3 * (4 - 3 * travel);
          }
        }
        const receded = item.portrait ? .42 : .55;
        const peak = item.portrait ? item.portraitPeak : 1;
        item.scale = receded + (peak - receded) * scaleProgress;
      });
      // Lay out the *displayed* image bounds, rather than the unscaled card
      // slots. This reserves room as an incoming photograph grows, and makes
      // adjacent gaps independent of the direction or speed of scrolling.
      const heroGap = item => item.panorama ? 38 : item.card.dataset.kvxFeaturedPortrait === 'true' ? 44 : 68;
      const stackedStory = window.innerWidth <= 989;
      const centers = [measurements[0]?.center];
      for (let index = 0; index < measurements.length - 1; index += 1) {
        const outgoing = measurements[index];
        const incoming = measurements[index + 1];
        const outgoingApex = outgoing.apexY;
        const incomingApex = incoming.apexY;
        const progress = Math.max(0, Math.min(1, (visualScrollY - outgoingApex) / (incomingApex - outgoingApex)));
        const openGap = heroGap(outgoing) + (heroGap(incoming) - heroGap(outgoing)) * progress;
        // The measured artwork bounds still determine placement. Only the
        // empty space between them contracts during the handover and reopens
        // at either dwell, so neither image can touch or overlap the next.
        const compression = Math.sin(Math.PI * progress) ** 2;
        const gap = openGap * (1 - .54 * compression);
        const panoramaStory = outgoing.panorama
          ? (outgoing.storyHeight + Math.min(38, Math.max(26, viewport * .035))) * Math.max(0, (outgoing.proximity - .12) / .88)
          : 0;
        const editorialBelow = !outgoing.panorama && stackedStory
          ? outgoing.storyHeight + outgoing.storyTop - outgoing.center - outgoing.height * outgoing.scale / 2
          : panoramaStory;
        centers.push(centers[index] + outgoing.height * outgoing.scale / 2 + editorialBelow + gap + incoming.height * incoming.scale / 2);
      }
      // A shared translation keeps the artwork nearest the exhibition stage
      // at its existing focus line; the measured pair spacing stays intact.
      const weights = measurements.map(item => item.proximity ** 4);
      let totalWeight = weights.reduce((sum, weight) => sum + weight, 0);
      if (!totalWeight && measurements.length) {
        const index = measurements.indexOf(measurements.find(item => item.card === nearest));
        weights[index] = 1;
        totalWeight = 1;
      }
      const offset = measurements.reduce((sum, item, index) =>
        sum + weights[index] * (item.center + item.lift - centers[index]), 0) / (totalWeight || 1);
      measurements.forEach((item, index) => {
        const displayedCenter = centers[index] + offset;
        const lift = displayedCenter - item.actualCenter;
        const storyLift = item.panorama
          ? displayedCenter + item.height * item.scale / 2 + Math.min(38, Math.max(26, viewport * .035)) - item.actualStoryTop
          : lift;
        item.displayedTop = displayedCenter - item.height * item.scale / 2;
        item.displayedBottom = displayedCenter + item.height * item.scale / 2;
        item.displayedStoryBottom = item.actualStoryTop + storyLift + item.storyHeight;
        item.visual.style.setProperty('--kvx-scale', item.scale.toFixed(4));
        item.visual.style.setProperty('--kvx-lift', `${lift.toFixed(1)}px`);
        item.story.style.setProperty('--kvx-story-lift', `${storyLift.toFixed(1)}px`);
      });
      // Let the panorama story recede before the advancing frame reaches it.
      // Its text never appears over the next photograph.
      measurements.forEach((item, index) => {
        if (!item.panorama) return;
        const next = measurements[index + 1];
        if (!next) return;
        const storyBottom = centers[index] + offset + item.height * item.scale / 2
          + Math.min(38, Math.max(26, viewport * .035)) + item.storyHeight;
        const nextTop = centers[index + 1] + offset - next.height * next.scale / 2;
        const clearance = Math.max(0, Math.min(1, (nextTop - storyBottom) / 30));
        item.story.style.setProperty('--kvx-story-opacity', (item.proximity ** 3 * clearance).toFixed(3));
      });
      // One divider pair and its background follow the complete hero composition.
      const compositionBottom = item => item.panorama
        ? (Number(item.story.style.getPropertyValue('--kvx-story-opacity')) > .08 ? Math.max(item.displayedBottom, item.displayedStoryBottom) : item.displayedBottom)
        : (stackedStory ? Math.max(item.displayedBottom, item.displayedStoryBottom) : item.displayedBottom);
      const heroIndex = measurements.findIndex(item => item.card === nearest);
      const hero = measurements[heroIndex];
      if (hero) {
        const item = hero;
        const index = heroIndex;
        const previous = measurements[index - 1];
        const next = measurements[index + 1];
        const above = previous ? compositionBottom(previous) : item.displayedTop - 64;
        const below = next ? next.displayedTop : compositionBottom(item) + 64;
        const topGap = item.displayedTop - above;
        const bottomGap = below - compositionBottom(item);
        const distance = Math.abs(item.center - item.line);
        const competitor = Math.min(...measurements.filter(other => other !== item).map(other => Math.abs(other.center - other.line)));
        const lead = Number.isFinite(competitor) ? competitor - distance : viewport;
        // The pair disappears before ownership transfers. A short interval
        // around the handover has no dividers from either artwork.
        const ownershipStep = Math.max(0, Math.min(1, (lead - viewport * .075) / (viewport * .19)));
        const ownership = ownershipStep * ownershipStep * (3 - 2 * ownershipStep);
        const opacity = item.proximity ** 6 * ownership * Math.max(0, Math.min(1, topGap / 18, bottomGap / 18));
        const upperY = (above + item.displayedTop) / 2 - rootTop;
        const lowerY = (compositionBottom(item) + below) / 2 - rootTop;
        apexLines[0].style.setProperty('--kvx-line-y', `${upperY.toFixed(1)}px`);
        apexLines[1].style.setProperty('--kvx-line-y', `${lowerY.toFixed(1)}px`);
        apexLines.forEach(line => line.style.setProperty('--kvx-line-opacity', opacity.toFixed(3)));
        apexZone.style.setProperty('--kvx-zone-y', `${upperY.toFixed(1)}px`);
        apexZone.style.setProperty('--kvx-zone-height', `${Math.max(0, lowerY - upperY).toFixed(1)}px`);
        apexZone.style.setProperty('--kvx-zone-opacity', opacity.toFixed(3));
      } else {
        apexLines.forEach(line => line.style.setProperty('--kvx-line-opacity', '0'));
        apexZone.style.setProperty('--kvx-zone-opacity', '0');
      }
    }
    if (nearest !== current) {
      current?.classList.remove('is-current');
      current = nearest;
      current?.classList.add('is-current');
      const index = visible.indexOf(current);
      [current, visible[index + 1]].forEach(card => {
        const img = card?.querySelector('.kvx-featured-editorial__artwork img');
        if (img) img.loading = 'eager';
      });
    }
    const last = measurements[measurements.length - 1];
    if (last) {
      const apexY = last.apexY;
      const reach = viewport * .82;
      const departure = clamp((visualScrollY - apexY - dwellHalf) / reach);
      const fullyGoneY = apexY + dwellHalf + reach;
      const holdEndY = fullyGoneY + viewport * .28;
      const releaseEndY = holdEndY + viewport * .45;
      const release = smooth(holdEndY, releaseEndY, visualScrollY);
      const darkness = smooth(.35, 1, departure);
      const arrival = smooth(.68, 1, departure);
      const screenOpacity = darkness * (1 - release);
      const contentOpacity = arrival * (1 - release);
      const normalDim = .76 * (1 - (last.proximity || 0));
      if (!motionPreference.matches) {
        last.visual.style.setProperty('--kvx-dim', Math.max(normalDim, smooth(.48, 1, departure)).toFixed(3));
        last.story.style.setProperty('--kvx-story-opacity', ((last.panorama ? last.proximity ** 3 : .22 + .78 * last.proximity) * (1 - smooth(.46, .94, departure))).toFixed(3));
      }
      const filterOpacity = 1 - smooth(.52, 1, departure);
      filterBar.style.opacity = filterOpacity.toFixed(3);
      filterBar.style.pointerEvents = filterOpacity < .05 ? 'none' : '';
      finaleScreen.style.setProperty('--kvx-finale-opacity', screenOpacity.toFixed(3));
      finaleContent.style.setProperty('--kvx-finale-content-opacity', contentOpacity.toFixed(3));
      finaleContent.style.setProperty('--kvx-finale-rise', `${((1 - arrival) * 28 - release * 14).toFixed(1)}px`);
      finaleContent.style.setProperty('--kvx-finale-scale', (1 + .014 * arrival - .028 * (1 - arrival)).toFixed(4));
      const interactive = contentOpacity > .4;
      finaleScreen.classList.toggle('is-interactive', interactive);
      finaleScreen.inert = !interactive;
      finaleScreen.setAttribute('aria-hidden', interactive ? 'false' : 'true');
      const neededHeight = Math.ceil(Math.max(viewport * 1.3, holdEndY + viewport + 24 - finaleTop - rootPadding));
      if (finale.dataset.height !== String(neededHeight)) {
        finale.style.setProperty('--kvx-finale-height', `${neededHeight}px`);
        finale.dataset.height = String(neededHeight);
      }
    }
    if (Math.abs(targetScrollY - visualScrollY) >= .25) queueFocus();
    if (nativeTouchScroll && !motionPreference.matches) {
      if (touchScrollHeld || Math.abs(touchScrollY - nativeTouchLastY) > .01) nativeTouchStillFrames = 0;
      else nativeTouchStillFrames += 1;
      nativeTouchLastY = touchScrollY;
      if (nativeTouchStillFrames < 4) queueFocus();
    }
  }

  function queueFocus() {
    if (!focusFrame) focusFrame = requestAnimationFrame(updateFocus);
  }

  function stopWheelMomentum() {
    if (wheelFrame) cancelAnimationFrame(wheelFrame);
    wheelFrame = 0;
    wheelFrameTime = 0;
    wheelVelocity = 0;
    wheelDriving = false;
  }

  function advanceWheel(now) {
    wheelFrame = 0;
    if (viewer.open || purchase.open || motionPreference.matches) {
      stopWheelMomentum();
      return;
    }
    const elapsed = wheelFrameTime ? Math.min(32, now - wheelFrameTime) : 16;
    wheelFrameTime = now;
    const decay = Math.exp(-elapsed / wheelDecayMs);
    const step = wheelVelocity * wheelDecayMs * (1 - decay);
    wheelVelocity *= decay;
    const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    wheelPosition = Math.max(0, Math.min(maxScroll, wheelPosition + step));
    window.scrollTo({ top: wheelPosition, behavior: 'instant' });
    // Commit the wheel scroll and its compensating transforms in one frame.
    // A separate focus rAF can run before this callback, leaving the native
    // page movement visible for a frame before dwell compensation catches up.
    if (focusFrame) cancelAnimationFrame(focusFrame);
    focusFrame = 0;
    updateFocus(now);
    if (Math.abs(wheelVelocity) > .015 && wheelPosition > 0 && wheelPosition < maxScroll) {
      wheelFrame = requestAnimationFrame(advanceWheel);
    } else {
      stopWheelMomentum();
    }
  }

  function onExhibitionWheel(event) {
    nativeTouchScroll = false;
    touchScrollHeld = false;
    if (viewer.open || purchase.open || motionPreference.matches || event.defaultPrevented || event.ctrlKey || !event.cancelable) {
      if (wheelDriving) stopWheelMomentum();
      return;
    }
    if (!event.deltaY || Math.abs(event.deltaX) > Math.abs(event.deltaY) * .6) return;
    const bounds = root.getBoundingClientRect();
    if (bounds.top >= window.innerHeight * .85 || bounds.bottom <= window.innerHeight * .15) return;
    const coarse = event.deltaMode !== WheelEvent.DOM_DELTA_PIXEL
      || (Math.abs(event.deltaY) >= 65 && Math.abs(event.deltaY - Math.round(event.deltaY)) < .001);
    const now = performance.now();
    if (!coarse) fineWheelUntil = now + 180;
    if (!coarse || now < fineWheelUntil) {
      if (wheelDriving) stopWheelMomentum();
      return;
    }
    event.preventDefault();
    const delta = event.deltaMode === WheelEvent.DOM_DELTA_LINE ? event.deltaY * 32
      : event.deltaMode === WheelEvent.DOM_DELTA_PAGE ? event.deltaY * window.innerHeight : event.deltaY;
    // A reversal discards the remaining coast, so the very next notch changes direction.
    if (!wheelDriving || (wheelVelocity && Math.sign(wheelVelocity) !== Math.sign(delta))) {
      wheelVelocity = 0;
      wheelPosition = window.scrollY;
    }
    wheelVelocity += delta / wheelDecayMs;
    wheelDriving = true;
    if (!wheelFrame) wheelFrame = requestAnimationFrame(advanceWheel);
  }

  function showViewerCard(card) {
    const data = dataFor(card)?.dataset;
    if (!data) return;
    viewerCard = card;
    const item = shortlistItem(card);
    const visible = visibleCards();
    viewerImage.onerror = () => { if (viewerImage.src !== item.thumb) viewerImage.src = item.thumb; };
    viewerImage.src = item.src || item.thumb;
    viewerImage.alt = item.title;
    sizeViewerImage();
    viewerTitle.textContent = item.title;
    viewerCounter.textContent = `${visible.indexOf(card) + 1} / ${visible.length}`;
    viewerHeart.dataset.kvxShortlistId = item.id;
    const saved = card.querySelector('.kvx-featured-editorial__visual [data-kvx-shortlist-id]')?.getAttribute('aria-pressed') === 'true';
    viewerHeart.setAttribute('aria-pressed', String(saved));
    viewerHeart.classList.toggle('is-saved', saved);
    root.querySelector('[data-kvx-viewer-prev]').disabled = visible.length < 2;
    root.querySelector('[data-kvx-viewer-next]').disabled = visible.length < 2;
  }

  function sizeViewerImage() {
    const thumb = viewerCard?.querySelector('.kvx-featured-editorial__artwork img');
    const ratio = (viewerImage.naturalWidth && viewerImage.naturalHeight ? viewerImage.naturalWidth / viewerImage.naturalHeight : thumb?.naturalWidth / thumb?.naturalHeight) || 1;
    const mobile = window.innerWidth <= 749;
    const width = Math.min(Math.max(1, window.innerWidth - (mobile ? 24 : 160)), Math.max(1, window.innerHeight - (mobile ? 150 : 110)) * ratio);
    viewerImage.style.width = `${Math.floor(width)}px`;
    viewerImage.style.height = `${Math.floor(width / ratio)}px`;
  }

  viewerImage.addEventListener('load', sizeViewerImage);

  function openViewer(card) {
    if (!card) return;
    viewerOrigin = card;
    viewerScrollY = window.scrollY;
    showViewerCard(card);
    if (!viewer.open) viewer.showModal();
  }

  function moveViewer(delta) {
    const visible = visibleCards();
    if (!visible.length || !viewerCard) return;
    showViewerCard(visible[(visible.indexOf(viewerCard) + delta + visible.length) % visible.length]);
  }

  function configureForm(form) {
    const selects = [...form.querySelectorAll('[data-kvx-option-select]')];
    const field = form.querySelector('[data-kvx-variant-id]');
    const button = form.querySelector('[data-kvx-add-to-cart]');
    const availability = form.querySelector('[data-kvx-availability]');
    const price = form.querySelector('[data-kvx-price]');
    let variants = [];
    try { variants = JSON.parse(form.dataset.variants || '[]'); } catch (error) { variants = []; }
    const syncVariant = () => {
      const values = selects.map(select => select.value);
      const variant = variants.find(candidate => Array.isArray(candidate.options) && candidate.options.every((value, index) => value === values[index]));
      if (!variant) {
        button.disabled = true;
        availability.textContent = 'Ez a kombináció jelenleg nem elérhető.';
        price.textContent = '';
        return;
      }
      field.value = variant.id;
      const available = variant.available !== false;
      button.disabled = !available;
      availability.textContent = available ? 'Elérhető konfiguráció.' : 'Ez a konfiguráció jelenleg nem elérhető.';
      availability.classList.toggle('is-unavailable', !available);
      price.textContent = typeof variant.price === 'number' ? new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF', maximumFractionDigits: 0 }).format(variant.price / 100) : '';
    };
    selects.forEach(select => select.addEventListener('change', syncVariant));
    syncVariant();
  }

  function openPurchase(card) {
    const data = dataFor(card);
    const template = purchaseTemplateFor(card);
    if (!data || !template) return;
    purchaseTitle.textContent = data.dataset.title || 'KOVEX ART nyomat';
    purchaseOptions.replaceChildren(template.content.cloneNode(true));
    productLink.href = data.dataset.productUrl || '#';
    configureForm(purchaseOptions.querySelector('[data-kvx-product-form]'));
    if (!purchase.open) purchase.showModal();
  }

  cards.forEach(renderStory);
  cards.forEach(card => card.querySelector('.kvx-featured-editorial__artwork img')?.addEventListener('load', queueFocus));
  root.addEventListener('click', event => {
    const trigger = event.target.closest('[data-kvx-featured-trigger]');
    if (!trigger || !root.contains(trigger)) return;
    event.preventDefault();
    const card = trigger.closest('[data-kvx-featured-entry]');
    if (card === current) openViewer(card);
    else card.scrollIntoView({ behavior: motionPreference.matches ? 'auto' : 'smooth', block: 'center' });
  });

  filters.forEach(button => {
    const filter = button.dataset.kvxFeaturedFilter;
    const matches = card => filter === 'all' || (filter === 'panorama' && card.dataset.kvxFeaturedPanorama === 'true') || (terms[filter] || []).some(term => normalize(card.dataset.kvxFeaturedTags).includes(term));
    if (filter !== 'all' && !cards.some(matches)) button.hidden = true;
    button.addEventListener('click', () => {
      const anchor = current;
      filters.forEach(item => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
      cards.forEach(card => { card.hidden = !matches(card); });
      const visible = visibleCards();
      const target = anchor && visible.includes(anchor) ? anchor : visible.find(card => cards.indexOf(card) >= cards.indexOf(anchor)) || visible[0];
      target?.scrollIntoView({ behavior: motionPreference.matches ? 'auto' : 'smooth', block: 'center' });
      queueFocus();
    });
  });

  root.querySelector('[data-kvx-viewer-close]').addEventListener('click', () => viewer.close());
  root.querySelector('[data-kvx-viewer-prev]').addEventListener('click', () => moveViewer(-1));
  root.querySelector('[data-kvx-viewer-next]').addEventListener('click', () => moveViewer(1));
  viewerHeart.addEventListener('click', () => {
    if (viewerCard) window.dispatchEvent(new CustomEvent('kvx-shortlist-toggle', { detail: shortlistItem(viewerCard) }));
  });
  viewer.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); moveViewer(-1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); moveViewer(1); }
  });
  viewerStage.addEventListener('pointerdown', event => {
    if (event.pointerType === 'touch' || event.pointerType === 'pen') touchStart = { x: event.clientX, y: event.clientY };
  });
  viewerStage.addEventListener('pointerup', event => {
    if (!touchStart) return;
    const dx = event.clientX - touchStart.x;
    const dy = event.clientY - touchStart.y;
    touchStart = null;
    if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy)) {
      viewerSwipeHandled = true;
      moveViewer(dx < 0 ? 1 : -1);
      window.setTimeout(() => { viewerSwipeHandled = false; }, 0);
    }
  });
  viewerImage.addEventListener('click', () => {
    if (!viewerSwipeHandled) viewer.close();
    viewerSwipeHandled = false;
  });
  viewer.addEventListener('close', () => {
    const restoreY = viewerScrollY;
    const restoreCard = viewerOrigin;
    viewerImage.removeAttribute('src');
    viewerCard = null;
    viewerOrigin = null;
    requestAnimationFrame(() => {
      restoreCard?.querySelector('[data-kvx-featured-trigger]')?.focus({ preventScroll: true });
      window.scrollTo(0, restoreY);
      queueFocus();
    });
  });
  root.querySelector('[data-kvx-purchase-close]').addEventListener('click', () => purchase.close());
  viewer.addEventListener('click', event => { if (event.target === viewer) viewer.close(); });
  purchase.addEventListener('click', event => { if (event.target === purchase) purchase.close(); });
  window.addEventListener('scroll', queueFocus, { passive: true });
  window.addEventListener('wheel', onExhibitionWheel, { passive: false });
  window.addEventListener('keydown', event => {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) {
      nativeTouchScroll = false;
      touchScrollHeld = false;
      if (wheelDriving) stopWheelMomentum();
    }
  }, { passive: true });
  window.addEventListener('touchstart', () => {
    if (wheelDriving) stopWheelMomentum();
    nativeTouchScroll = true;
    touchScrollHeld = true;
    nativeTouchStillFrames = 0;
    nativeTouchLastY = window.visualViewport?.pageTop ?? window.scrollY;
    queueFocus();
  }, { passive: true });
  const releaseTouchScroll = () => { touchScrollHeld = false; queueFocus(); };
  window.addEventListener('touchend', releaseTouchScroll, { passive: true });
  window.addEventListener('touchcancel', releaseTouchScroll, { passive: true });
  window.visualViewport?.addEventListener('scroll', queueFocus, { passive: true });
  window.addEventListener('pointerdown', event => {
    if (event.pointerType === 'mouse') nativeTouchScroll = false;
    if (wheelDriving) stopWheelMomentum();
  }, { passive: true });
  window.addEventListener('resize', () => { if (viewer.open) sizeViewerImage(); queueFocus(); }, { passive: true });
  motionPreference.addEventListener?.('change', queueFocus);
  queueFocus();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-presets"] && !Shopify.designMode) return;
  try {
    
(() => {
  const presets = document.querySelector('[data-kvx-presets]');
  const archive = document.querySelector('[data-kvx-archive]');
  if (!presets || !archive || presets.dataset.ready === 'true') return;
  presets.dataset.ready = 'true';

  presets.addEventListener('click', event => {
    const card = event.target.closest('[data-preset-group]');
    if (!card) return;
    event.preventDefault();
    const group = card.dataset.presetGroup;
    const value = card.dataset.presetValue;

    const reset = archive.querySelector('[data-filter-reset]');
    if (reset) reset.click();

    const targetGroup = archive.querySelector(`[data-filter-group="${CSS.escape(group)}"]`);
    if (!targetGroup) return;
    const button = [...targetGroup.querySelectorAll('[data-filter-value]')].find(b => b.dataset.filterValue === value && !b.hidden);
    if (button && !button.disabled) button.click();
    setTimeout(() => archive.scrollIntoView({behavior:'smooth',block:'start'}), 40);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kikoto-index"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-kikoto-index]').forEach(function (root) {
  var isTouch = window.matchMedia('(hover: none)').matches;
  if (isTouch) {
    var markers = root.querySelectorAll('.kikoto-map__marker');
    markers.forEach(function (marker) {
      marker.addEventListener('click', function (e) {
        if (!marker.classList.contains('is-open')) {
          e.preventDefault();
          markers.forEach(function (m) {
            m.classList.remove('is-open');
          });
          marker.classList.add('is-open');
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.kikoto-map__marker')) {
        markers.forEach(function (m) {
          m.classList.remove('is-open');
        });
      }
    });
  }

  var toggles = root.querySelectorAll('[data-kikoto-dropdown-toggle]');
  function closeAllDropdowns(except) {
    toggles.forEach(function (t) {
      if (t !== except) {
        t.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = true;
      }
    });
  }
  toggles.forEach(function (toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns(toggle);
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.hidden = isOpen;
    });
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        toggle.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        toggle.focus();
      }
    });
  });
  if (toggles.length) {
    document.addEventListener('click', function () {
      closeAllDropdowns();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDropdowns();
    });
  }

  var directory = root.querySelector('[data-kikoto-directory]');
  if (directory) {
    var activeFilters = { shore: 'all', basin: 'all' };
    var filterButtons = directory.querySelectorAll('[data-kikoto-filter]');
    var directoryCards = directory.querySelectorAll('[data-kikoto-directory-card]');
    var directoryGroups = directory.querySelectorAll('[data-kikoto-directory-group]');

    function applyDirectoryFilters() {
      directoryCards.forEach(function (card) {
        var shoreMatches = activeFilters.shore === 'all' || card.dataset.shore === activeFilters.shore;
        var basinMatches = activeFilters.basin === 'all' || card.dataset.basin === activeFilters.basin;
        card.hidden = !(shoreMatches && basinMatches);
      });
      directoryGroups.forEach(function (group) {
        group.hidden = !group.querySelector('[data-kikoto-directory-card]:not([hidden])');
      });
    }

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.dataset.kikotoFilter;
        activeFilters[filter] = button.dataset.kikotoValue;
        directory.querySelectorAll('[data-kikoto-filter="' + filter + '"]').forEach(function (candidate) {
          var isActive = candidate === button;
          candidate.classList.toggle('is-active', isActive);
          candidate.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        applyDirectoryFilters();
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kvx-beyond-intro"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kvx-beyond-intro')){
customElements.define('kvx-beyond-intro',class extends HTMLElement{
connectedCallback(){
this.frame=this.querySelector('.kvx-wing__hero');this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.visible=false;this.raf=0;
this.queue=()=>{if(this.raf||!this.visible||this.reduced.matches||innerWidth<750)return;this.raf=requestAnimationFrame(()=>{this.raf=0;const r=this.frame.getBoundingClientRect(),p=Math.max(0,Math.min(1,(innerHeight-r.top)/(innerHeight+r.height)))-.5;this.style.setProperty('--kvx-wing-y',(p*20).toFixed(2)+'px');});};
this.reset=()=>{this.style.removeProperty('--kvx-wing-y');this.queue();};
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.queue();});this.observer.observe(this.frame);
addEventListener('scroll',this.queue,{passive:true});addEventListener('resize',this.reset,{passive:true});this.reduced.addEventListener('change',this.reset);
}
disconnectedCallback(){cancelAnimationFrame(this.raf);this.observer?.disconnect();removeEventListener('scroll',this.queue);removeEventListener('resize',this.reset);this.reduced?.removeEventListener('change',this.reset);}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kvx-home-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kvx-home-editorial')) {
    customElements.define('kvx-home-editorial', class extends HTMLElement {
      connectedCallback() {
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.frameId = 0;
        this.queue = () => {
          if (!this.visible || this.motionPreference.matches || this.frameId) return;
          this.frameId = requestAnimationFrame(() => {
            this.frameId = 0;
            this.updateMotion();
          });
        };
        this.preferenceChanged = () => {
          if (this.motionPreference.matches) {
            cancelAnimationFrame(this.frameId);
            this.frameId = 0;
            this.style.removeProperty('--kvx-editorial-image-y');
            this.style.removeProperty('--kvx-editorial-image-scale');
            this.style.removeProperty('--kvx-editorial-text-y');
          } else this.queue();
        };
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.queue();
        }, { rootMargin: '120px 0px' });
        this.observer.observe(this);
        this.resizeObserver = new ResizeObserver(this.queue);
        this.resizeObserver.observe(this);
        window.addEventListener('scroll', this.queue, { passive: true });
        window.addEventListener('resize', this.queue, { passive: true });
        this.motionPreference.addEventListener('change', this.preferenceChanged);
      }

      updateMotion() {
        const rect = this.getBoundingClientRect();
        const viewportHeight = document.documentElement.clientHeight;
        const progress = Math.max(0, Math.min(1, (viewportHeight - rect.top) / (viewportHeight + rect.height)));
        const offset = progress - .5;
        const mobile = window.innerWidth < 750;
        this.style.setProperty('--kvx-editorial-image-y', `${(offset * (mobile ? 20 : 40)).toFixed(2)}px`);
        this.style.setProperty('--kvx-editorial-image-scale', (1.045 + progress * .025).toFixed(4));
        this.style.setProperty('--kvx-editorial-text-y', `${(offset * (mobile ? -12 : -32)).toFixed(2)}px`);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frameId);
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        window.removeEventListener('scroll', this.queue);
        window.removeEventListener('resize', this.queue);
        this.motionPreference?.removeEventListener('change', this.preferenceChanged);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kvx-home-ribbon"] && !Shopify.designMode) return;
  try {
    
/* Photo ribbon: native horizontal scroller + slow drift + a boost from vertical page-scroll velocity.
 * Never preventDefault()s a touch/wheel gesture; no scroll-snap. Loop = first set + aria-hidden copies. */
(() => {
  const root = document.documentElement;
  if (root.dataset.kvxRibbonBound) return;
  root.dataset.kvxRibbonBound = '1';

  const BASE = { off: 0, slow: 12, medium: 24 }; // px per second
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (v, lim) => Math.max(-lim, Math.min(lim, v));
  const instances = new Map();

  const setup = (el) => {
    if (el.dataset.kvxReady) return;
    const track = el.querySelector('[data-kvx-ribbon-track]');
    const strip = track && track.firstElementChild;
    if (!strip || !strip.firstElementChild) return;
    el.dataset.kvxReady = '1';

    const first = strip.firstElementChild;
    const base = BASE[el.dataset.speed] ?? BASE.slow;
    let W = 0; // width of one set (= loop period)
    let pos = track.scrollLeft; // float accumulator; scrollLeft itself rounds
    let written = pos; // what scrollLeft read back after our last write
    let boost = 0; // px/s, from vertical page scroll
    let ease = 0; // eased base speed so pauses and resumes are gradual
    let raf = 0;
    let last = 0;
    let userT = -1e9; // last time the user touched / moved the ribbon
    let visible = true;
    let down = false;
    let hover = false;
    let drag = null;
    let suppress = false;
    let unsub = null;

    const measure = () => {
      if (strip.children.length < 2) return;
      W = strip.children[1].getBoundingClientRect().left - strip.children[0].getBoundingClientRect().left;
      if (W < 8) { W = 0; return; }
      // Enough copies that scrollLeft can stay in [W, 2W) with a full period of buffer on both sides.
      while (strip.children.length < Math.ceil(track.clientWidth / W) + 2) {
        const c = first.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a').forEach((a) => { a.tabIndex = -1; });
        c.querySelectorAll('[data-shopify-editor-block]').forEach((n) => n.removeAttribute('data-shopify-editor-block'));
        strip.appendChild(c);
      }
    };

    const tick = (t) => {
      raf = requestAnimationFrame(tick);
      const dt = last ? Math.min((t - last) / 1000, 0.1) : 0;
      last = t;
      const cur = track.scrollLeft;
      if (Math.abs(cur - written) > 1) { pos = cur; userT = t; } // moved by finger, wheel, drag or keyboard
      boost *= Math.exp(-dt * 3);
      if (Math.abs(boost) < 1) boost = 0;
      if (!W || down || t - userT < 250) return; // never write while the user is in control (would cancel momentum)
      const still = reduce.matches || hover || t - userT < 2000; // pause drift: reduced motion, hover, 2s after interaction
      ease += ((still ? 0 : base) - ease) * (1 - Math.exp(-dt * 4));
      if (!reduce.matches) pos += (ease + (still ? 0 : boost)) * dt;
      if (pos < W || pos >= 2 * W) pos = W + ((((pos - W) % W) + W) % W); // seamless wrap in both directions
      if (Math.abs(pos - written) > 0.001) { track.scrollLeft = pos; written = track.scrollLeft; }
    };

    const run = () => {
      if (visible && !document.hidden) {
        if (!raf) { last = 0; raf = requestAnimationFrame(tick); }
      } else if (raf) {
        cancelAnimationFrame(raf);
        raf = 0;
      }
    };

    const end = () => {
      down = false;
      userT = performance.now();
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', end);
      window.removeEventListener('pointercancel', end);
      track.classList.remove('is-dragging');
      if (drag && drag.moved) { suppress = true; setTimeout(() => { suppress = false; }, 0); }
      drag = null;
    };
    function move(e) {
      if (!drag) return;
      if (!e.buttons) return end(); // button released outside the window
      const dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 5) { drag.moved = true; track.classList.add('is-dragging'); }
      if (drag.moved) track.scrollLeft = drag.s - dx;
    }

    track.addEventListener('pointerdown', (e) => {
      down = true;
      userT = performance.now();
      drag = e.pointerType === 'mouse' && e.button === 0 ? { x: e.clientX, s: track.scrollLeft, moved: false } : null;
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    });
    track.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hover = true; });
    track.addEventListener('pointerleave', () => { hover = false; });
    track.addEventListener('dragstart', (e) => e.preventDefault());
    track.addEventListener('click', (e) => { if (suppress) { e.preventDefault(); e.stopPropagation(); } }, true);

    const onBoost = (dy) => { if (visible && !reduce.matches) boost = clamp(boost + clamp(dy, 120), 900); };
    const hook = () => { if (!unsub && window.KVXMotion) unsub = window.KVXMotion.onScroll(onBoost); };
    hook();
    if (!unsub) window.addEventListener('load', hook, { once: true });

    const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => { visible = es[0].isIntersecting; run(); }) : null;
    const ro = 'ResizeObserver' in window ? new ResizeObserver(measure) : null;
    if (io) io.observe(el);
    if (ro) { ro.observe(track); ro.observe(first); } else window.addEventListener('resize', measure);
    document.addEventListener('visibilitychange', run);
    measure();
    run();

    instances.set(el, () => {
      cancelAnimationFrame(raf);
      raf = 0;
      end();
      if (io) io.disconnect();
      if (ro) ro.disconnect();
      if (unsub) unsub();
      window.removeEventListener('resize', measure);
      window.removeEventListener('load', hook);
      document.removeEventListener('visibilitychange', run);
    });
  };

  const init = (scope) => (scope || document).querySelectorAll('[data-kvx-ribbon]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-kvx-ribbon]').forEach((el) => {
      const destroy = instances.get(el);
      if (destroy) destroy();
      instances.delete(el);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kvx-product-category"]) return;
  try {
    
if (!customElements.get('kvx-product-notification')) {
  customElements.define('kvx-product-notification', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.dialog = this.querySelector('[data-product-notify-dialog]');
      this.opener = this.querySelector('[data-product-notify-open]');
      if (!this.dialog || !this.opener) return;
      this.openDialog = () => {
        if (this.dialog.open) return;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        (this.dialog.querySelector('[data-product-notify-response]') || this.dialog.querySelector('input[type=email]'))?.focus();
      };
      this.opener.addEventListener('click', this.openDialog, options);
      this.querySelector('[data-product-notify-close]')?.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow;
        this.opener.focus({ preventScroll: true });
      }, options);
      if (this.dialog.querySelector('[data-product-notify-response]')) this.openDialog();
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.events?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kvx-products-landing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kvx-products-landing')) {
  customElements.define('kvx-products-landing', class extends HTMLElement {
    connectedCallback() {
      this.rows = [...this.querySelectorAll('[data-kvx-product-category]')];
      this.visible = new Set();
      this.frameId = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.desktop = matchMedia('(min-width: 750px)');
      this.queue = () => {
        if (this.frameId || this.motion.matches || !this.desktop.matches || !this.visible.size) return;
        this.frameId = requestAnimationFrame(() => {
          this.frameId = 0;
          const viewport = document.documentElement.clientHeight;
          this.visible.forEach(row => {
            const rect = row.getBoundingClientRect();
            const progress = Math.max(0, Math.min(1, (viewport - rect.top) / (viewport + rect.height))) - .5;
            row.style.setProperty('--kvx-products-y', (progress * 24).toFixed(2) + 'px');
            row.style.setProperty('--kvx-products-text-y', (progress * -16).toFixed(2) + 'px');
          });
        });
      };
      this.reset = () => {
        cancelAnimationFrame(this.frameId);
        this.frameId = 0;
        this.rows.forEach(row => {
          row.style.removeProperty('--kvx-products-y');
          row.style.removeProperty('--kvx-products-text-y');
        });
        this.queue();
      };
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => entry.isIntersecting ? this.visible.add(entry.target) : this.visible.delete(entry.target));
        this.queue();
      }, { rootMargin: '80px 0px' });
      this.rows.forEach(row => this.observer.observe(row));
      this.resizeObserver = new ResizeObserver(this.queue);
      this.resizeObserver.observe(this);
      window.addEventListener('scroll', this.queue, { passive: true });
      window.addEventListener('resize', this.queue, { passive: true });
      this.motion.addEventListener('change', this.reset);
      this.desktop.addEventListener('change', this.reset);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frameId);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      window.removeEventListener('scroll', this.queue);
      window.removeEventListener('resize', this.queue);
      this.motion?.removeEventListener('change', this.reset);
      this.desktop?.removeEventListener('change', this.reset);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kvx-service-accordion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kvx-service-accordion')) {
  customElements.define('kvx-service-accordion', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('[data-service-panel]')];
      this.active = -1;
      this.editorBlock = null;
      this.hoverMode = matchMedia('(min-width:750px) and (hover:hover) and (pointer:fine)');
      this.mobileMode = matchMedia('(max-width:749px)');
      this.panels.forEach((panel, index) => {
        panel.addEventListener('pointerenter', event => {
          if (this.hoverMode.matches && event.pointerType === 'mouse' && !this.editorBlock && !this.querySelector(':focus-visible')) this.activate(index);
        }, options);
        panel.querySelector('[data-service-toggle]').addEventListener('click', event => {
          this.activate(this.hoverMode.matches && event.detail > 0 ? index : this.active === index ? -1 : index);
        }, options);
        panel.addEventListener('focusin', event => {
          if (event.target.matches('[data-service-toggle]:focus-visible')) this.activate(index);
        }, options);
      });
      this.addEventListener('pointerleave', event => {
        if (this.hoverMode.matches && event.pointerType === 'mouse' && !this.editorBlock && !this.querySelector(':focus-visible')) this.activate(-1);
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget) && !this.editorBlock && !this.matches(':hover')) this.activate(-1);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          this.querySelector('.is-active [data-service-toggle]')?.focus({preventScroll:true});
          this.activate(-1);
        }
        if (['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key) && event.target.matches('[data-service-toggle]')) {
          event.preventDefault();
          const current = this.panels.indexOf(event.target.closest('[data-service-panel]'));
          const step = ['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 1;
          const next = (current + step + this.panels.length) % this.panels.length;
          this.panels[next].querySelector('[data-service-toggle]').focus({preventScroll:true});
          this.activate(next);
        }
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.editorBlock = event.detail.blockId;
        this.activate(index);
      }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (this.editorBlock === event.detail.blockId) {
          this.editorBlock = null;
          this.activate(-1);
        }
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.layout());
      this.resizeObserver.observe(this);
      this.layout();
      this.classList.add('is-ready');
    }
    activate(index) {
      this.active = index;
      this.classList.toggle('has-active', index >= 0);
      this.panels.forEach((panel, i) => {
        const open = i === index;
        panel.classList.toggle('is-active', open);
        panel.querySelector('[data-service-toggle]').setAttribute('aria-expanded', String(open));
        const details = panel.querySelector('.kvx-service-panel__details');
        details.inert = !open;
        details.setAttribute('aria-hidden', String(!open));
      });
      this.layout();
    }
    layout() {
      const rect = this.getBoundingClientRect();
      const mobile = this.mobileMode.matches;
      const axis = mobile ? rect.height : rect.width;
      if (!axis || !this.panels.length) return;
      const cross = mobile ? rect.width : rect.height;
      const angle = Number(this.dataset.angle) * Math.PI / 180;
      const slant = Math.min(cross * Math.tan(angle) / 2 / axis * 100, 4.5);
      this.style.setProperty('--kvx-slant', `${slant}%`);
      const overscan = 2 * slant / 100 * axis;
      this.style.setProperty('--kvx-photo-width', `${rect.width * Math.max(.75,1 / this.panels.length) + (mobile ? 0 : overscan)}px`);
      this.style.setProperty('--kvx-photo-height', `${rect.height * Math.max(.75,1 / this.panels.length) + (mobile ? overscan : 0)}px`);
      this.style.setProperty('--kvx-idle-title-width', `${Math.max(80,rect.width / this.panels.length - 2 * slant * rect.width / 100 - 32)}px`);
      let start = 0;
      this.panels.forEach((panel, i) => {
        const share = this.active < 0 ? 100 / this.panels.length : this.panels.length === 1 ? 100 : i === this.active ? 75 : 25 / (this.panels.length - 1);
        const center = start + share / 2;
        panel.style.setProperty('--kvx-start', `${start}%`);
        panel.style.setProperty('--kvx-end', `${start + share}%`);
        panel.style.setProperty('--kvx-center', `${center}%`);
        panel.style.setProperty('--kvx-center-px', `${center / 100 * axis}px`);
        start += share;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kvx-wallpaper-signup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kvx-wallpaper-signup')) {
  customElements.define('kvx-wallpaper-signup', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.dialog = this.querySelector('[data-wallpaper-dialog]');
      this.opener = this.querySelector('[data-wallpaper-open]');
      if (!this.dialog || !this.opener) return;
      this.open = () => {
        if (this.dialog.open) return;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        (this.dialog.querySelector('[data-wallpaper-response]') || this.dialog.querySelector('input[type=email]'))?.focus();
      };
      this.restore = () => {
        document.documentElement.style.overflow = this.previousOverflow;
        this.opener.focus({ preventScroll: true });
      };
      this.opener.addEventListener('click', this.open, options);
      this.querySelector('[data-wallpaper-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', this.restore, options);
      if (this.dialog.querySelector('[data-wallpaper-response]')) this.open();
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow;
      }
      this.events?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-photo-slideshow"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.service-gallery').forEach((root) => {
  if (root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  const slider = root.querySelector('[data-slider]');
  if (!slider) return;
  const track = slider.querySelector('.service-gallery__track');
  const slides = [...slider.querySelectorAll('[data-slide]')];
  const dots = [...slider.querySelectorAll('[data-dot]')];
  if (!track || slides.length < 2) return;
  let index = 0;
  const render = () => {
    track.style.transform = `translateX(${-index * 100}%)`;
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
  };
  const go = (n) => {
    index = (n + slides.length) % slides.length;
    render();
  };
  slider.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1));
  slider.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1));
  dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
  let startX = null;
  slider.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
  slider.addEventListener('touchend', (e) => {
    if (startX === null) return;
    const delta = e.changedTouches[0].clientX - startX;
    if (Math.abs(delta) > 45) go(index + (delta < 0 ? 1 : -1));
    startX = null;
  }, { passive: true });
});

  } catch(e) { console.error(e); }
})();
})();
